/**
 * az-index.js — tô đậm chữ cái đang xem trên thanh tra cứu A–Z.
 *
 * Markup: [data-az] chứa các a.az-bar__link trỏ tới #id của từng nhóm.
 * Việc nhảy tới nhóm do anchor của trình duyệt lo (CSS đã đặt scroll-margin-top
 * để không bị header dính che), script này chỉ theo dõi vị trí cuộn.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var bar = document.querySelector('[data-az]');
    if (!bar) return;

    var links = [].slice.call(bar.querySelectorAll('a.az-bar__link[href^="#"]'));
    var pairs = [];

    links.forEach(function (link) {
        var group = document.querySelector(link.getAttribute('href'));
        if (group) pairs.push({ link: link, group: group });
    });
    if (!pairs.length) return;

    var ticking = false;

    function offset() {
        var header = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
        );
        // +40: khớp với scroll-margin-top của .brand-group để nhóm vừa nhảy tới
        // được tính là nhóm đang xem, không lùi lại chữ cái trước đó.
        return (isNaN(header) ? 190 : header) + bar.offsetHeight + 40;
    }

    function update() {
        var limit = offset();
        var current = null;

        pairs.forEach(function (pair) {
            if (pair.group.getBoundingClientRect().top <= limit) current = pair;
        });

        pairs.forEach(function (pair) {
            pair.link.classList.toggle('is-active', pair === current);
        });
    }

    window.addEventListener(
        'scroll',
        function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                update();
                ticking = false;
            });
        },
        { passive: true }
    );

    update();
})();
